import React from 'react';
import {useIntl} from 'react-intl';
import {LiteEmptyPage} from './LiteEmptyPage';

export const LiteDefaultPage = () => {
  const intl = useIntl();
  return (
    <LiteEmptyPage>
      <p>{intl.formatMessage({id: 'studioLite.default.1'})}</p>
      <p>
        {intl.formatMessage(
          {id: 'studioLite.default.2'},
          {
            learnLink: (
              <a
                href="https://www.blaize.com/products/ai-studio/"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            ),
          }
        )}
      </p>
    </LiteEmptyPage>
  );
};
